export default __webpack_public_path__ + "f08f2a269f2ae0a812579b219b702893.jpg";